import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 004_add_lead_numbering — #427 follow-up (Path C)
//
// Adds the `lead_no` column to `crm_leads` so the doctype can be registered
// with `numberingField: "lead_no"` (matching the existing pattern for
// deal_no, quotation_no, booking_no, etc). Until this lands, lead lived
// outside the doctype registry — see modules/crm/doctypes.ts:85 for the
// historical "no lead_no column" caveat.
//
// Idempotency is handled by the migration runner — `runModuleMigrations`
// (server) and `migrate-tenant.mjs` (local script) both treat
// "duplicate column" as success, so re-running this after first apply is
// a no-op without an explicit guard.
// ============================================================================

export const migration: ModuleMigrationDef = {
  key: "004_add_lead_numbering",
  version: "1.0.0",
  sql: `ALTER TABLE \`crm_leads\` ADD COLUMN \`lead_no\` text;`,
};
